/* ---- from the v2 preview: v2.js ---- */
/* LOOKEE® homepage v2: interaction without libraries.
   Site-wide: small ® in display type, reveals, header and buy bar, menu sheet, footnotes, the reduce-motion switch.
   (The homepage itself runs on the ln-* sections and lk-home.js.) */
(function () {
  'use strict';
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function motionOff() { return html.getAttribute('data-motion') === 'off'; }

  try { sessionStorage.setItem('lk-settled', '1'); } catch (e) {}

  /* ---------------------------------------------------------------------------------------
     0. Small ® in display type (Rubik draws it at full cap height).
  --------------------------------------------------------------------------------------- */
  $$('.hero__product, .h2, .h3, .menu__list a, .cmp__head span, .footer__tag, .btn, .textlink, .pull blockquote, .hairlist__title, .footer__cols h2, [data-reg], .plp__title, .drawer__title').forEach(function (node) {
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), texts = [], t;
    while ((t = walker.nextNode())) if (t.nodeValue.indexOf('®') > -1) texts.push(t);
    texts.forEach(function (tn) {
      var parts = tn.nodeValue.split('®'), frag = document.createDocumentFragment();
      parts.forEach(function (p, i) {
        if (p) frag.appendChild(document.createTextNode(p));
        if (i < parts.length - 1) { var s = document.createElement('span'); s.className = 'reg'; s.textContent = '®'; frag.appendChild(s); }
      });
      tn.parentNode.replaceChild(frag, tn);
    });
  });

  /* ---------------------------------------------------------------------------------------
     4. Chapters appear once, gently. Visible immediately with motion off.
  --------------------------------------------------------------------------------------- */
  var reveals = $$('[data-reveal]');
  function revealAll() { reveals.forEach(function (r) { r.classList.add('is-in'); }); }
  if (motionOff() || !('IntersectionObserver' in window)) revealAll();
  else {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (r) { ro.observe(r); });
  }

  /* ---------------------------------------------------------------------------------------
     5. Header hairline, one orange button per screen, mobile buy bar.
  --------------------------------------------------------------------------------------- */
  var header = $('[data-header]'), headBuy = $('[data-head-buy]'), buybar = $('[data-buybar]'), menu = $('[data-menu]');
  var visibleBuy = new Set(), mainBuy = $('.buyform [data-buy]');
  function syncBuy() {
    var none = visibleBuy.size === 0;
    if (headBuy) headBuy.classList.toggle('is-buy', none && window.scrollY > 200);
    if (buybar) {
      // the bar comes in once the main Add to cart has been scrolled past, not while a hero sits above it
      var past = !mainBuy || mainBuy.getBoundingClientRect().bottom < 0;
      var on = none && past && (!menu || menu.hidden);
      buybar.classList.toggle('is-on', on);
      buybar.setAttribute('aria-hidden', on ? 'false' : 'true');
      buybar.querySelector('a, button').tabIndex = on ? 0 : -1;
    }
  }
  if ('IntersectionObserver' in window) {
    var bo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) visibleBuy.add(e.target); else visibleBuy.delete(e.target); });
      syncBuy();
    }, { threshold: 0.5 });
    $$('[data-buy]').forEach(function (b) { bo.observe(b); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; if (header) header.classList.toggle('is-stuck', header.getBoundingClientRect().top <= 0 && window.scrollY > 40); syncBuy(); });
  }, { passive: true });

  /* ---------------------------------------------------------------------------------------
     6. Menu sheet: focus stays inside, Escape closes, page behind is inert.
        In-page links close the sheet, scroll, and move focus to the chapter heading.
  --------------------------------------------------------------------------------------- */
  var openBtn = $('[data-menu-open]'), closeBtn = $('[data-menu-close]');
  var behind = [$('main'), $('[data-footer]'), header, $('.announce')];
  function setMenu(open, returnFocus) {
    menu.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    behind.forEach(function (b) { if (b) { if (open) b.setAttribute('inert', ''); else b.removeAttribute('inert'); } });
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { menu.classList.remove('is-opening'); void menu.offsetWidth; menu.classList.add('is-opening'); closeBtn.focus(); }
    else if (returnFocus !== false) openBtn.focus();
    syncBuy();
  }
  function focusTarget(id) {
    var t = document.getElementById(id); if (!t) return;
    var h = t.matches('h1, h2') ? t : t.querySelector('h1, h2');
    t.scrollIntoView({ behavior: motionOff() ? 'auto' : 'smooth', block: 'start' });
    if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }
  if (menu && openBtn && closeBtn) {
  openBtn.addEventListener('click', function () { setMenu(true); });
  closeBtn.addEventListener('click', function () { setMenu(false); });
  $$('[data-menu-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href.charAt(0) === '#') { e.preventDefault(); setMenu(false, false); focusTarget(href.slice(1)); }
      else setMenu(false, false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (!menu || menu.hidden) return;
    if (e.key === 'Escape') { setMenu(false); return; }
    if (e.key === 'Tab') {
      var f = $$('a, button', menu), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  }

  /* ---------------------------------------------------------------------------------------
     7. Footnotes: each note's "Back to the text" returns to the reference that was clicked.
  --------------------------------------------------------------------------------------- */
  $$('sup a[href^="#fn"]').forEach(function (a) {
    a.addEventListener('click', function () {
      var n = a.getAttribute('href').replace('#fn', ''), back = $('[data-back="' + n + '"]');
      if (back && a.id) back.setAttribute('href', '#' + a.id);
    });
  });

  /* ---------------------------------------------------------------------------------------
     9. Reduce motion switch in the footer (saved per visitor).
  --------------------------------------------------------------------------------------- */
  var mt = $('[data-motion-toggle]');
  if (mt) {
    mt.setAttribute('aria-pressed', motionOff() ? 'true' : 'false');
    mt.addEventListener('click', function () {
      var off = !motionOff();
      if (off) html.setAttribute('data-motion', 'off'); else html.removeAttribute('data-motion');
      try { localStorage.setItem('lk-motion', off ? 'off' : 'on'); } catch (e) {}
      if (off) { revealAll(); }
      mt.setAttribute('aria-pressed', off ? 'true' : 'false');
      // Product pages listen for this to stop any clip that is already playing.
      try { document.dispatchEvent(new CustomEvent('lk:motion', { detail: { off: off } })); } catch (e) {}
    });
  }
})();

/* ---- from the v2 preview: pdp.js ---- */
/* LOOKEE® v2 product pages: gallery, lightbox, options, quantity, gift card, cart drawer, feature explorer,
   film, reviews. No libraries. Nothing moves on its own except short silent product loops, which never play
   when motion is reduced and always have a pause button. The cart is a design preview kept in this browser
   (localStorage, with an in-memory fallback); in the live store Shopify's cart takes over. */
(function () {
  'use strict';
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function motionOff() { return html.getAttribute('data-motion') === 'off'; }
  function money(v) { return ((window.LK && LK.moneyPrefix) || '$') + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function json(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function abs(u) { try { return u ? new URL(u, location.href).href : ''; } catch (e) { return u || ''; } }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }
  var FREE = 39.99;
  // In the Shopify theme, window.LK.routes exists: the cart talks to Shopify and prices arrive in cents.
  var SHOP = window.LK && window.LK.routes && window.LK.routes.cartAdd ? window.LK.routes : null;

  /* -------------------------------------------------------------------------------------------
     Videos: load on demand, play only while shown and only with motion on, always pausable.
  ------------------------------------------------------------------------------------------- */
  function syncVidBtn(v) {
    var b = v.parentNode.querySelector('[data-vid-toggle]');
    if (!b) return;
    b.hidden = false;
    b.classList.toggle('is-paused', v.paused);
    b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
  }
  function loadVid(v) { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; }
  function showVid(v, on) {
    if (!v) return;
    if (on) {
      loadVid(v);
      if (!motionOff() && !v.dataset.userPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      syncVidBtn(v);
    } else if (!v.paused) v.pause();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vid-toggle]');
    if (!b) return;
    var v = b.parentNode.querySelector('video'); loadVid(v);
    if (v.paused) { delete v.dataset.userPaused; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else { v.pause(); v.dataset.userPaused = '1'; }
  });
  document.addEventListener('play', function (e) { if (e.target.tagName === 'VIDEO') syncVidBtn(e.target); }, true);
  document.addEventListener('pause', function (e) { if (e.target.tagName === 'VIDEO') syncVidBtn(e.target); }, true);
  // The footer's Reduce motion switch also stops clips that are already playing.
  document.addEventListener('lk:motion', function (e) {
    if (!e.detail || !e.detail.off) return;
    $$('video').forEach(function (v) { if (v.controls) return; if (!v.paused) v.pause(); if (v.getAttribute('src')) syncVidBtn(v); });
  });

  /* -------------------------------------------------------------------------------------------
     Gallery: swipe or arrows, thumbnails on wide screens, keyboard, count. Tap opens the lightbox.
     Three Tab stops: the current photo, Previous, Next.
  ------------------------------------------------------------------------------------------- */
  var gal = $('[data-gallery]'), track, slides = [], cur = 0, lbItems = [], jumpTo = null, jumpT = 0, galVisible = true;
  function setArrow(b, off) { if (!b) return; b.setAttribute('aria-disabled', off ? 'true' : 'false'); }
  function goTo(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    var how = smooth === false || motionOff() ? 'auto' : 'smooth';
    if (how === 'smooth') { jumpTo = i; clearTimeout(jumpT); jumpT = setTimeout(function () { jumpTo = null; }, 2000); }
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: how });
    setCur(i);
  }
  function keepThumbInView(b) {
    var t = b.closest('.thumbs'); if (!t || t.offsetParent === null) return;
    var li = b.parentNode, how = motionOff() ? 'auto' : 'smooth';
    if (t.scrollHeight > t.clientHeight + 2) {
      var tp = li.offsetTop - t.offsetTop, bt = tp + li.offsetHeight;
      if (tp < t.scrollTop + 8 || bt > t.scrollTop + t.clientHeight - 8) t.scrollTo({ top: tp - t.clientHeight / 2 + li.offsetHeight / 2, behavior: how });
    }
  }
  function syncMask() {
    var t = gal && $('.thumbs', gal); if (!t) return;
    t.classList.toggle('has-more', t.scrollHeight > t.clientHeight + 2 && t.scrollTop + t.clientHeight < t.scrollHeight - 4);
  }
  function setCur(i) {
    cur = i;
    $('[data-count]', gal).textContent = String(i + 1);
    $$('[data-goto]', gal).forEach(function (b) {
      if (+b.dataset.goto === i) { b.setAttribute('aria-current', 'true'); keepThumbInView(b); }
      else b.removeAttribute('aria-current');
    });
    $$('[data-zoom]', gal).forEach(function (b) { b.tabIndex = +b.dataset.zoom === i ? 0 : -1; });
    setArrow($('[data-prev]', gal), i === 0);
    setArrow($('[data-next]', gal), i === slides.length - 1);
    slides.forEach(function (s, k) { showVid(s.querySelector('video'), k === i && galVisible); });
  }
  if (gal) {
    track = $('[data-track]', gal);
    slides = $$('[data-slide]', gal);
    lbItems = json($('[data-lb-items]', gal)) || [];
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (jumpTo !== null) {                                    // a programmatic jump: ignore the slides it passes
          if (Math.abs(track.scrollLeft - (slides[jumpTo].offsetLeft - track.offsetLeft)) > 2) return;
          jumpTo = null;
        }
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur) setCur(i);
      });
    }, { passive: true });
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (t) { track.addEventListener(t, function () { jumpTo = null; }, { passive: true }); });
    track.addEventListener('scrollend', function () { jumpTo = null; });
    $$('[data-goto]', gal).forEach(function (b) { b.addEventListener('click', function () { goTo(+b.dataset.goto); }); });
    var pv = $('[data-prev]', gal), nx = $('[data-next]', gal);
    if (pv) pv.addEventListener('click', function () { if (pv.getAttribute('aria-disabled') !== 'true') goTo(cur - 1); });
    if (nx) nx.addEventListener('click', function () { if (nx.getAttribute('aria-disabled') !== 'true') goTo(cur + 1); });
    gal.addEventListener('keydown', function (e) {
      if (!e.target.closest('.gal__stage')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); focusZoom(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); focusZoom(); }
    });
    function focusZoom() { var z = $('[data-zoom="' + cur + '"]', gal); if (z && document.activeElement && document.activeElement.closest('.gal__track')) z.focus({ preventScroll: true }); }
    $$('[data-zoom]', gal).forEach(function (b) { b.addEventListener('click', function () { openLb(+b.dataset.zoom, b); }); });
    var th = $('.thumbs', gal); if (th) { th.addEventListener('scroll', syncMask, { passive: true }); window.addEventListener('resize', syncMask); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { galVisible = es[0].isIntersecting; slides.forEach(function (s, k) { showVid(s.querySelector('video'), k === cur && galVisible); }); }, { threshold: 0.3 }).observe(track);
    }
    setCur(0);
    syncMask();
  }

  /* Lightbox */
  var lb = $('[data-lightbox]'), lbTrack, lbCur = 0, lbReturn = null;
  function lbCount() {
    $('[data-lb-count]', lb).textContent = (lbCur + 1) + ' / ' + lbItems.length;
    setArrow($('[data-lb-prev]', lb), lbCur === 0);
    setArrow($('[data-lb-next]', lb), lbCur === lbItems.length - 1);
  }
  function lbGo(i, smooth) {
    var lis = $$('li', lbTrack); if (!lis.length) return;
    lbCur = Math.max(0, Math.min(lis.length - 1, i));
    lbTrack.scrollTo({ left: lis[lbCur].offsetLeft, behavior: smooth === false || motionOff() ? 'auto' : 'smooth' });
    lbCount();
  }
  function openLb(i, from) {
    if (!lb || !lbItems.length) return;
    lbTrack = $('[data-lb-track]', lb);
    if (!lbTrack.children.length) {
      lbTrack.innerHTML = lbItems.map(function (it) {
        if (it.kind === 'video') return '<li><video controls muted loop playsinline preload="none" poster="' + esc(it.poster) + '" src="' + esc(it.src) + '" aria-label="' + esc(it.alt) + '"></video></li>';
        return '<li><img src="' + esc(it.src) + '" alt="' + esc(it.alt) + '"' + (it.kind === 'cdn' ? ' class="is-cdn"' : '') + ' loading="lazy"></li>';
      }).join('');
      var r2 = 0;
      lbTrack.addEventListener('scroll', function () {
        cancelAnimationFrame(r2);
        r2 = requestAnimationFrame(function () { var k = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth)); if (k !== lbCur) { lbCur = k; lbCount(); } });
      }, { passive: true });
      // A click on the empty backdrop closes the view.
      lbTrack.addEventListener('click', function (e) { if (e.target === lbTrack || e.target.tagName === 'LI') closeLb(); });
      var one = lbItems.length < 2;
      $('[data-lb-prev]', lb).hidden = one; $('[data-lb-next]', lb).hidden = one; $('[data-lb-count]', lb).hidden = one;
    }
    lbReturn = from || document.activeElement;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    setInert(true, lb);
    lbGo(i, false);
    $('[data-lb-close]', lb).focus();
  }
  function closeLb() {
    if (!lb || lb.hidden) return;
    $$('video', lb).forEach(function (v) { v.pause(); });
    lb.hidden = true;
    document.body.style.overflow = '';
    setInert(false, lb);
    if (gal) goTo(lbCur, false);
    var z = gal && $('[data-zoom="' + lbCur + '"]', gal);
    var back = z || lbReturn;
    if (back && back.focus) back.focus({ preventScroll: true });
  }
  if (lb) {
    $('[data-lb-close]', lb).addEventListener('click', closeLb);
    $('[data-lb-prev]', lb).addEventListener('click', function () { lbGo(lbCur - 1); });
    $('[data-lb-next]', lb).addEventListener('click', function () { lbGo(lbCur + 1); });
  }

  /* Page behind a dialog is inert; Tab stays inside; Escape closes. */
  function setInert(on, except) {
    [$('main'), $('[data-footer]'), $('[data-header]'), $('.announce'), $('[data-pdpbar]'), $('[data-buybar]'), $('.skip')].forEach(function (el) {
      if (!el || el === except) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function trap(e, box) {
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), textarea, video[controls], [tabindex="0"]', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === box || !box.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (lb && !lb.hidden) {
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbCur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbCur - 1); }
      else if (e.key === 'Tab') trap(e, lb);
    } else if (drawer && !drawer.hidden) {
      if (e.key === 'Escape') closeCart();
      else if (e.key === 'Tab') trap(e, $('.drawer__panel', drawer));
    }
  });

  /* -------------------------------------------------------------------------------------------
     Options, quantity, price, gift card.
  ------------------------------------------------------------------------------------------- */
  var form = $('[data-buyform]'), variants = [], selected = null;
  function clampQty(n) { n = parseInt(n, 10); if (isNaN(n) || n < 1) n = 1; if (n > 99) n = 99; return n; }
  function setQty(n) {
    var inp = $('[data-qty-input]', form); n = clampQty(n); inp.value = n;
    var dn = $('[data-qty="-1"]', form); if (dn) dn.setAttribute('aria-disabled', n <= 1 ? 'true' : 'false');
  }
  function pickVariant(i) {
    selected = variants.filter(function (v) { return v.i === +i; })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (!selected) return;
    var idInput = form.querySelector('input[name="id"]'); if (idInput && selected.id) idInput.value = selected.id;
    $('[data-price]').textContent = money(selected.price);
    var was = $('[data-was]');
    if (selected.compare) {
      was.hidden = false;
      $('[data-compare]', was).textContent = money(selected.compare);
      $('[data-save]', was).textContent = 'You save ' + money(selected.compare - selected.price);
    } else was.hidden = true;
    var unit = $('[data-unit]');
    if (unit) unit.textContent = money(selected.price / +unit.dataset.unit) + ' per ' + unit.dataset.unitWord;
    var ov = $('[data-opt-value]', form); if (ov) ov.textContent = cap(selected.value);
    var bp = $('[data-bar-price]'); if (bp) bp.textContent = money(selected.price);
    var bo = $('[data-bar-opt]'); if (bo && ov) bo.textContent = ', ' + cap(selected.value);
    var bi = $('[data-pdpbar] img'); if (bi) bi.src = selected.bar || bi.dataset.default;
    var add = $('[data-add]', form), now = $('[data-buynow]', form), barAdd = $('[data-bar-add]');
    [add, now, barAdd].forEach(function (b) { if (b) b.disabled = !selected.available; });
    add.textContent = selected.available ? 'Add to cart' : 'Sold out';
    if (barAdd) barAdd.textContent = selected.available ? 'Add to cart' : 'Sold out';
    if (selected.image && lbItems.length) {
      var raw = selected.image.split('?')[0];
      for (var k = 0; k < lbItems.length; k++) if (lbItems[k].raw && lbItems[k].raw === raw) { goTo(k); break; }
    }
  }
  var gift = form && $('[data-gift]', form);
  function giftCheck() {
    if (!gift || !$('[data-gift-toggle]', gift).checked) return { ok: true, note: '' };
    var em = $('[data-gift-email]', gift), err = $('[data-gift-error]', gift), v = em.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      em.setAttribute('aria-invalid', 'true');
      err.textContent = v ? 'Check the recipient email address. It needs an @ and a domain, for example name@example.com.' : 'Enter the recipient email address.';
      em.focus();
      return { ok: false };
    }
    em.removeAttribute('aria-invalid'); err.textContent = '';
    var nm = $('[data-gift-name]', gift).value.trim(), dt = $('[data-gift-date]', gift).value, msg = $('[data-gift-msg]', gift).value.trim();
    // Shopify's own gift card recipient properties.
    var props = { __shopify_send_gift_card_to_recipient: 'on', 'Recipient email': v };
    if (nm) props['Recipient name'] = nm;
    if (msg) props['Message'] = msg;
    if (dt) props['Send on'] = dt;
    return { ok: true, note: 'For ' + (nm ? nm + ', ' : '') + v + (dt ? ', sent on ' + dt : ''), props: props };
  }
  if (form) {
    variants = json($('[data-variants]', form)) || [];
    if (SHOP) variants.forEach(function (v) { v.price = v.price / 100; v.compare = v.compare ? v.compare / 100 : null; });
    var checked = $('input[name="variant"]:checked', form);
    pickVariant(checked ? checked.value : (variants[0] ? variants[0].i : 0));
    $$('input[name="variant"]', form).forEach(function (r) { r.addEventListener('change', function () { pickVariant(r.value); }); });
    $$('[data-qty]', form).forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('aria-disabled') === 'true') return; setQty(clampQty($('[data-qty-input]', form).value) + +b.dataset.qty); }); });
    $('[data-qty-input]', form).addEventListener('change', function (e) { setQty(e.target.value); });
    setQty(1);
    form.addEventListener('submit', function (e) { e.preventDefault(); addCurrent(false); });
    var buyNow = $('[data-buynow]', form);       // the theme may show Shopify's own express button instead
    if (buyNow) buyNow.addEventListener('click', function () { addCurrent(true); });
    var barAddBtn = $('[data-bar-add]'); if (barAddBtn) barAddBtn.addEventListener('click', function () { addCurrent(false); });
    if (gift) {
      var tg = $('[data-gift-toggle]', gift), flds = $('[data-gift-fields]', gift);
      tg.addEventListener('change', function () { flds.hidden = !tg.checked; tg.setAttribute('aria-expanded', String(tg.checked)); if (tg.checked) $('[data-gift-email]', gift).focus(); });
    }
  }

  /* Buy bar: shown while the main Add to cart is out of view, hidden while the footer is on screen. */
  var bar = $('[data-pdpbar]'), mainAdd = form && $('[data-add]', form), menuEl = $('[data-menu]'), addIn = true, footIn = false;
  function applyBar() {
    if (!bar) return;
    var on = !addIn && !footIn && (!menuEl || menuEl.hidden);
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    $('button', bar).tabIndex = on ? 0 : -1;
  }
  if (bar && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { addIn = es[es.length - 1].isIntersecting; applyBar(); }).observe(mainAdd);
    var ft = $('[data-footer]');
    if (ft) new IntersectionObserver(function (es) { footIn = es[es.length - 1].isIntersecting; applyBar(); }).observe(ft);
    if (menuEl && 'MutationObserver' in window) new MutationObserver(applyBar).observe(menuEl, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* -------------------------------------------------------------------------------------------
     Cart. One interface, two stores: the design preview keeps lines in localStorage; the Shopify
     theme uses Shopify's cart API. Lines are normalised to
     { key, name, variant, price (dollars), qty, img, url, ships }.
  ------------------------------------------------------------------------------------------- */
  var drawer = $('[data-drawer]'), drawerReturn = null, mem = [], lines = [];
  if (drawer && drawer.dataset.free) FREE = +drawer.dataset.free;
  function notify() { try { document.dispatchEvent(new CustomEvent('lk:cart')); } catch (e) {} }
  var LocalCart = {
    read: function () { try { var v = JSON.parse(localStorage.getItem('lk-cart') || '[]'); return Array.isArray(v) ? v : mem; } catch (e) { return mem; } },
    write: function (c) { mem = c; try { localStorage.setItem('lk-cart', JSON.stringify(c)); } catch (e) {} },
    get: function () { return Promise.resolve(LocalCart.read()); },
    add: function (line, qty) {
      var c = LocalCart.read(), f = c.filter(function (it) { return it.key === line.key; })[0];
      if (f) f.qty = Math.min(99, f.qty + qty); else { line.qty = qty; c.push(line); }
      LocalCart.write(c); return Promise.resolve(c);
    },
    set: function (k, qty) { var c = LocalCart.read(); if (qty <= 0) c.splice(k, 1); else c[k].qty = qty; LocalCart.write(c); return Promise.resolve(c); },
    checkout: function () { return false; }
  };
  function shortName(t) { return String(t || '').split(' | ')[0].split(': ')[0]; }
  function fromShopify(cart) {
    return (cart.items || []).map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return (o.name === 'Title' ? 'Amount' : o.name) + ': ' + cap(o.value); });
      var pr = it.properties || {};
      var to = pr['Recipient email'] ? 'For ' + (pr['Recipient name'] ? pr['Recipient name'] + ', ' : '') + pr['Recipient email'] : '';
      var img = it.image ? it.image + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=200' : '';
      return { key: it.key, name: shortName(it.product_title), variant: opts.concat(to ? [to] : []).join('. '), price: it.final_price / 100,
               qty: it.quantity, img: img, url: it.url, ships: it.requires_shipping !== false };
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Something went wrong. Please try again.'); return d; }); });
  }
  var ShopifyCart = {
    get: function () { return fetch(SHOP.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(fromShopify); },
    add: function (line, qty) {
      var item = { id: line.id, quantity: qty };
      if (line.properties) item.properties = line.properties;
      return post(SHOP.cartAdd + '.js', { items: [item] }).then(ShopifyCart.get);
    },
    set: function (k, qty) { return post(SHOP.cartChange + '.js', { line: k + 1, quantity: qty }).then(fromShopify); },
    checkout: function () { location.href = (SHOP.root || '/').replace(/\/?$/, '/') + 'checkout'; return true; }
  };
  var Cart = SHOP ? ShopifyCart : LocalCart;

  function count(c) { return c.reduce(function (n, it) { return n + (+it.qty || 0); }, 0); }
  function updateCount() {
    var n = count(lines);
    $$('[data-cart-count]').forEach(function (el) { el.hidden = n === 0; el.textContent = String(n); });
    $$('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-label', n ? 'Cart, ' + n + ' item' + (n > 1 ? 's' : '') : 'Cart, empty'); });
  }
  function paint() { updateCount(); if (drawer) render(); renderPage(); }
  function use(c) { lines = c; paint(); notify(); return c; }
  function refresh() { return Cart.get().then(use).catch(function () { return lines; }); }
  function shipLine(box, noteEl, c) {
    var shipSub = c.reduce(function (s, it) { return s + (it.ships === false ? 0 : it.price * it.qty); }, 0);
    var anyShip = c.some(function (it) { return it.ships !== false; });
    if (!c.length) { box.hidden = false; box.innerHTML = esc(box.dataset.empty || 'Free shipping over $39.99 USD / CAD$46.'); return; }
    if (!anyShip) { box.hidden = true; if (noteEl) noteEl.textContent = 'Taxes are calculated at checkout.'; }
    else if (shipSub >= FREE) { box.hidden = false; box.innerHTML = 'You have free shipping.<i style="--w: 100%"></i>'; if (noteEl) noteEl.textContent = 'Shipping is free. Taxes are calculated at checkout.'; }
    else { box.hidden = false; box.innerHTML = 'You are ' + money(FREE - shipSub) + ' away from free shipping.<i style="--w: ' + (shipSub / FREE * 100).toFixed(1) + '%"></i>'; if (noteEl) noteEl.textContent = 'Taxes and shipping are calculated at checkout.'; }
  }
  function lineHtml(it, k, page) {
    var unit = page ? '<p class="caption">' + (it.qty > 1 ? it.qty + ' × ' : '') + money(it.price) + (it.qty > 1 ? ' each' : '') + '</p>'
                    : (it.qty > 1 ? '<p class="caption">' + it.qty + ' × ' + money(it.price) + '</p>' : '');
    return '<li>' + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '<span></span>') +
      '<a class="drawer__name" href="' + esc(it.url) + '">' + esc(it.name) + '</a>' +
      (it.variant ? '<p>' + esc(it.variant) + '</p>' : '') + unit +
      '<div class="drawer__line"><div class="qty" role="group" aria-label="Quantity of ' + esc(it.name) + '">' +
      '<button class="qty__btn" type="button" data-cq="' + k + '" data-d="-1" aria-label="One fewer ' + esc(it.name) + '"' + (it.qty <= 1 ? ' aria-disabled="true"' : '') + '><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12"/></svg></button>' +
      '<span class="qty__input" style="display:grid;place-items:center">' + (+it.qty || 0) + '</span>' +
      '<button class="qty__btn" type="button" data-cq="' + k + '" data-d="1" aria-label="One more ' + esc(it.name) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M10 4v12"/></svg></button></div>' +
      '<span' + (page ? ' class="cartpage__total"' : '') + '>' + money(it.price * it.qty) + '</span></div>' +
      '<button class="textbtn" type="button" data-rm="' + k + '">Remove <span class="vh">' + esc(it.name) + '</span></button></li>';
  }
  function emptyHtml(allHref) {
    return '<li class="drawer__empty"><p>Your cart is empty.</p>' + (allHref ? '<p><a class="textlink" href="' + esc(allHref) + '"><span>See all products</span><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M11 5l5 5-5 5"/></svg></a></p>' : '') + '</li>';
  }
  function render() {
    var c = lines, list = $('[data-cart-items]', drawer);
    var sub = c.reduce(function (s, it) { return s + it.price * it.qty; }, 0);
    list.innerHTML = c.length ? c.map(function (it, k) { return lineHtml(it, k, false); }).join('') : emptyHtml(drawer.dataset.all ? abs(drawer.dataset.all) : '');
    $('[data-cart-subtotal]', drawer).textContent = money(sub);
    $('[data-cart-foot]', drawer).hidden = !c.length;
    $('.drawer__more', drawer).hidden = !c.length;
    shipLine($('[data-cart-ship]', drawer), $('[data-cart-note]', drawer), c);
  }
  function addLine(line, qty) { return Cart.add(line, qty).then(use); }
  function buyError(msg) {
    var e = form && $('[data-buy-error]', form);
    if (e) { e.textContent = msg; e.hidden = !msg; }
  }
  function addCurrent(now) {
    if (!form || !selected || !selected.available) return;
    var g = giftCheck(); if (!g.ok) return;
    buyError('');
    var qty = clampQty($('[data-qty-input]', form).value);
    var lg = $('.opts__legend', form), val = selected.value && selected.value !== 'Default Title' && variants.length > 1 ? cap(selected.value) : '';
    var label = val ? (lg ? lg.firstChild.nodeValue.replace(/[:\s]+$/, '') + ': ' : '') + val : '';
    if (g.note) label = (label ? label + '. ' : '') + g.note;
    var add = $('[data-add]', form);
    add.disabled = true;
    addLine({ key: form.dataset.handle + '#' + selected.i + (g.note ? '#' + g.note : ''), id: selected.id, properties: g.props, name: form.dataset.name,
              variant: label, price: selected.price, img: abs(selected.thumb || form.dataset.thumb), url: abs(form.dataset.url), ships: form.dataset.ships !== 'false' }, qty)
      .then(function () {
        add.disabled = false;
        if (now && Cart.checkout()) return;
        add.textContent = 'Added'; add.classList.add('is-done');
        setTimeout(function () { add.textContent = selected.available ? 'Add to cart' : 'Sold out'; add.classList.remove('is-done'); }, 1600);
        openCart('Added to your cart.', now);
      })
      .catch(function (err) { add.disabled = false; buyError(err.message); });
  }
  function openCart(msg, now) {
    if (!drawer) return;
    render();
    var status = $('[data-cart-status]', drawer);
    status.textContent = '';
    $('[data-checkout-note]', drawer).hidden = !now || !!SHOP;
    drawerReturn = document.activeElement;
    drawer.hidden = false;
    drawer.classList.remove('is-opening'); void drawer.offsetWidth; drawer.classList.add('is-opening');
    document.body.style.overflow = 'hidden';
    setInert(true, drawer);
    $('#drawer-title', drawer).focus();
    if (msg) setTimeout(function () { status.textContent = msg; }, 150);   // written after the dialog shows, so it is announced
  }
  function closeCart() {
    drawer.hidden = true;
    document.body.style.overflow = '';
    setInert(false, drawer);
    var back = drawerReturn && drawerReturn !== document.body && document.contains(drawerReturn) && drawerReturn.offsetParent !== null ? drawerReturn : ($('[data-add]') || $('[data-cart-open]'));
    if (back && back.focus) back.focus({ preventScroll: true });
  }
  // Quantity buttons and Remove, shared by the drawer and the cart page.
  function onLineClick(box, statusEl, titleSel) {
    box.addEventListener('click', function (e) {
      var qb = e.target.closest('[data-cq]'), rm = e.target.closest('[data-rm]');
      if (!qb && !rm) return;
      if (qb && qb.getAttribute('aria-disabled') === 'true') return;
      var k = +(qb || rm).dataset[qb ? 'cq' : 'rm'], d = qb ? +qb.dataset.d : 0, it = lines[k];
      if (!it) return;
      var qty = qb ? Math.max(1, Math.min(99, it.qty + d)) : 0;
      Cart.set(k, qty).then(use).then(function () {
        var again;
        if (qb) {
          again = box.querySelector('[data-cq="' + k + '"][data-d="' + d + '"]');
          if (again && again.getAttribute('aria-disabled') === 'true') again = box.querySelector('[data-cq="' + k + '"][data-d="1"]');
        } else again = box.querySelector('.drawer__name');
        if (!again) { again = $(titleSel); if (again) again.setAttribute('tabindex', '-1'); }
        if (again) again.focus();
        statusEl.textContent = qb ? 'Quantity of ' + it.name + ': ' + qty + '.' : 'Removed ' + it.name + ' from your cart.';
      }).catch(function (err) { statusEl.textContent = err.message; });
    });
  }
  if (drawer) {
    $$('[data-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', closeCart); });
    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(function () { openCart(''); }); }); });
    onLineClick(drawer, $('[data-cart-status]', drawer), '#drawer-title');
    $('[data-checkout]', drawer).addEventListener('click', function () { if (!Cart.checkout()) $('[data-checkout-note]', drawer).hidden = false; });
  }

  /* Cart page: the same lines as the drawer, with room to read. */
  var cp = $('[data-cart-page]');
  function renderPage() {
    if (!cp) return;
    var c = lines, list = $('[data-cartpage-items]', cp), sum = $('[data-cartpage-sum]', cp);
    if (!c.length) { list.innerHTML = emptyHtml(abs(cp.dataset.all)); sum.hidden = true; return; }
    sum.hidden = false;
    list.innerHTML = c.map(function (it, k) { return lineHtml(it, k, true); }).join('');
    $('[data-cartpage-subtotal]', cp).textContent = money(c.reduce(function (s, it) { return s + it.price * it.qty; }, 0));
    shipLine($('[data-cartpage-ship]', cp), $('[data-cartpage-note]', cp), c);
  }
  if (cp) {
    onLineClick(cp, $('[data-cartpage-status]', cp), '#cart-title');
    cp.addEventListener('click', function (e) { if (e.target.closest('[data-cartpage-checkout]') && !Cart.checkout()) $('[data-cartpage-proto]', cp).hidden = false; });
  }
  refresh();

  /* One-tap add for a second product shown on the page (for example the pack of 2). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    var d; try { d = JSON.parse(b.getAttribute('data-quick-add')); } catch (x) { return; }
    addLine({ key: d.key, id: d.id, name: d.name, variant: d.variant || '', price: d.price, img: abs(d.img), url: abs(d.url), ships: d.ships !== false }, 1)
      .then(function () { openCart('Added to your cart.'); })
      .catch(function (err) { var s = drawer && $('[data-cart-status]', drawer); if (s) { openCart(''); s.textContent = err.message; } });
  });

  /* -------------------------------------------------------------------------------------------
     Feature explorer: one feature open at a time. Wide screens show its picture in the sticky
     stage; phones show it inside the open feature. Some features offer a choice (Ring or Ring Pro).
  ------------------------------------------------------------------------------------------- */
  var wide = window.matchMedia('(min-width: 1000px)');
  function initFx(root) { $$('[data-fx]', root).forEach(function (fx) {
    if (fx.__fx) return; fx.__fx = true;
    var btns = $$('[data-fx-btn]', fx), frames = $$('[data-fx-frame]', fx), items = $$('[data-fx-item]', fx), on = 0, seen = false;
    function playCurrent() {
      $$('video', fx).forEach(function (v) { showVid(v, false); });
      if (!seen) return;
      var box = wide.matches ? frames[on] : items[on];
      if (box) $$('video', box).forEach(function (v) { if (v.offsetParent !== null) showVid(v, true); });
    }
    function open(i, user) {
      if (i === on && user && !wide.matches) {           // phones: tapping the open feature closes it
        var p0 = $('#' + btns[i].getAttribute('aria-controls'));
        var isOpen = btns[i].getAttribute('aria-expanded') === 'true';
        btns[i].setAttribute('aria-expanded', String(!isOpen)); p0.hidden = isOpen; items[i].classList.toggle('is-on', !isOpen);
        playCurrent(); return;
      }
      on = i;
      btns.forEach(function (b, k) {
        var p = $('#' + b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', String(k === i)); p.hidden = k !== i;
        items[k].classList.toggle('is-on', k === i);
      });
      frames.forEach(function (f, k) { f.classList.toggle('is-on', k === i); if (k === i) f.removeAttribute('inert'); else f.setAttribute('inert', ''); });
      playCurrent();
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { open(k, true); }); });
    fx.addEventListener('click', function (e) {
      var c = e.target.closest('[data-fx-choice]'); if (!c) return;
      var item = c.closest('[data-fx-item]'), n = c.dataset.fxChoice, idx = +item.dataset.fxItem;
      $$('[data-fx-choice]', item).forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
      $$('[data-fx-choice-text]', item).forEach(function (x) { x.hidden = x.dataset.fxChoiceText !== n; });
      [item, frames[idx]].forEach(function (box) { if (box) $$('[data-fx-choice-shot]', box).forEach(function (x) { x.hidden = x.dataset.fxChoiceShot !== n; }); });
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; playCurrent(); }, { threshold: 0.25 }).observe(fx);
    if (wide.addEventListener) wide.addEventListener('change', playCurrent);
    fx.__open = open;
  }); }
  initFx(document);

  /* Inline loops elsewhere: play while on screen. */
  var vo = null;
  if ('IntersectionObserver' in window) {
    vo = new IntersectionObserver(function (es) { es.forEach(function (e) { showVid(e.target, e.isIntersecting); }); }, { threshold: 0.4 });
  }
  function initLoops(root) { if (vo) $$('.shot--video video', root).forEach(function (v) { if (!v.closest('[data-fx]') && !v.__vo) { v.__vo = true; vo.observe(v); } }); }
  initLoops(document);

  // Theme editor: sections re-rendered after a change get their behaviour back; selecting a feature block opens it.
  document.addEventListener('shopify:section:load', function (e) { initFx(e.target); initLoops(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-fx-item]'), fx = item && item.closest('[data-fx]');
    if (fx && fx.__open) fx.__open(+item.dataset.fxItem);
  });
})();

/* Announcement bar: next message every 4 seconds; waits while hovered or focused or when the tab is hidden; still when motion is off */
(function () {
  'use strict';
  var bar = document.querySelector('[data-announce]');
  if (!bar) return;
  var slides = bar.querySelectorAll('.announce__slide');
  if (slides.length < 2) return;
  if (document.documentElement.getAttribute('data-motion') === 'off' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var i = 0, hold = false;
  bar.addEventListener('mouseenter', function () { hold = true; });
  bar.addEventListener('mouseleave', function () { hold = false; });
  bar.addEventListener('focusin', function () { hold = true; });
  bar.addEventListener('focusout', function () { hold = false; });
  setInterval(function () {
    if (hold || document.hidden) return;
    var now = slides[i], next = slides[(i + 1) % slides.length];
    next.classList.add('announce__slide--ready');
    next.classList.remove('is-off');
    void next.offsetWidth;
    now.classList.remove('is-on');
    now.classList.add('is-off');
    next.classList.add('is-on');
    i = (i + 1) % slides.length;
    setTimeout(function () { now.classList.remove('is-off'); }, 700);
  }, 4000);
})();
